import React from 'react';
import ReactDOM from 'react-dom';
import pageConfig from '@PROJECT_ROOT/responsiveFrontendPagesConfiguration.json';
import BlogContent from '@PROJECT_ROOT/assets/responsive-frontend/pages/Blog/BlogContent';
import GlobalPageComponents from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/globalPageComponents';

const blog = document.getElementById(pageConfig.blogPage.id);
if (blog) {
    const ssrData = window.SSR_DATA || null;
    ReactDOM.hydrate(
        <>
            <GlobalPageComponents />
            <BlogContent publicResourcesSSR={ssrData} />
        </>,
        blog,
    );
}
